import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { format } from "date-fns";
import AdminNavbar from "./AdminNavbar";

const Wrapper = styled.div`
  font-family: "Inter", sans-serif;
  background-color: #f9f9f9;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 30px;
`;

const Card = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
`;

const Title = styled.h2`
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
`;

const RevenueSummary = styled.div`
  margin-bottom: 20px;
  padding: 18px 24px;
  border-radius: 12px;
  background-color: #e8faff;
  border: 1px solid #b6e3f0;
  font-size: 15px;
  color: #007991;
  font-weight: 500;
  line-height: 1.7;

  span {
    color: #007991;
    font-weight: 700;
  }
`;


const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th,
  td {
    padding: 12px 10px;
    border-bottom: 1px solid #eee;
    text-align: left;
  }

  th {
    background-color: #f1f3f5;
    color: #333;
    font-weight: 600;
  }

  td {
    color: #444;
  }
`;

const licenseColors = {
  "DEMO BASIC - 7 dni": "#FFC107",
  "DEMO EXTENDED - 15 dni": "#FF9800",
  "STANDARD - 1 miesiąc": "#2196F3",
  "STANDARD - 6 miesięcy": "#1976D2",
  "STANDARD - 1 rok": "#0D47A1",
  "PRO - 1 miesiąc": "#4CAF50",
  "PRO - 6 miesięcy": "#388E3C",
  "PRO - 1 rok": "#1B5E20",
  "ENTERPRISE - 1 miesiąc": "#9C27B0",
  "ENTERPRISE - 6 miesięcy": "#7B1FA2",
  "ENTERPRISE - 1 rok": "#4A148C",
  "NO EXPIRE": "#FF5722",
};

const Przychody = () => {
  const [orders, setOrders] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const adminUser = JSON.parse(localStorage.getItem("adminUser"));
  const role = adminUser?.userRole;
  const kodbonus = adminUser?.Kodbonus;

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get("https://server229256.nazwa.pl/api/orders");
        setOrders(res.data);

        if (role === "SUPERADMIN") {
          setFiltered(res.data);
        } else if (role === "INFLUENCER" && kodbonus) {
          const filteredByCode = res.data.filter(order => order.creatorCode === kodbonus);
          setFiltered(filteredByCode);
        }
      } catch (error) {
        console.error("❌ Error loading orders:", error);
      }
    };

    fetchOrders();
  }, [role, kodbonus]);

  // Calculate earnings for the current month
  const now = new Date();
  const monthRevenue = filtered
    .filter(
      order =>
        order.status === "paid" &&
        new Date(order.creationTime).getMonth() === now.getMonth() &&
        new Date(order.creationTime).getFullYear() === now.getFullYear()
    )
    .reduce((acc, order) => acc + parseFloat(order.price || 0), 0);

  // Calculate total earnings
  const totalRevenue = filtered
    .filter(order => order.status === "paid")
    .reduce((acc, order) => acc + parseFloat(order.price || 0), 0);

  return (
    <Wrapper>
      <AdminNavbar />
      <Content>
        <Card>
          <Title>Twoje przychody</Title>

          {role === "INFLUENCER" && (
      <RevenueSummary>
      Twój kod: <span>{kodbonus || "—"}</span> <br />
      Zarobek w tym miesiącu (2%):{" "}
      <span>{(monthRevenue * 0.02).toFixed(2)} zł</span> &nbsp;
      <strong style={{ fontWeight: 400, fontSize: "13px", color: "#666" }}>
        (na podstawie {monthRevenue.toFixed(2)} zł)
      </strong>
      <br />
      Łącznie (2%):{" "}
      <span>{(totalRevenue * 0.02).toFixed(2)} zł</span> &nbsp;
      <strong style={{ fontWeight: 400, fontSize: "13px", color: "#666" }}>
        (na podstawie {totalRevenue.toFixed(2)} zł)
      </strong>
    </RevenueSummary>
    
      
          )}

          <Table>
            <thead>
              <tr>
                <th>Licencja</th>
                <th>Cena</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length > 0 ? (
                filtered.map(order => (
                  <tr key={order._id}>
                
                    <td>
                      {order.license ? (
                        <span
                          style={{
                            backgroundColor: licenseColors[order.license] || "#999",
                            color: "white",
                            padding: "4px 8px",
                            borderRadius: "6px",
                            fontWeight: "bold",
                          }}
                        >
                          {order.license}
                        </span>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>{order.price} zł</td>
                    <td>{format(new Date(order.creationTime), "yyyy-MM-dd HH:mm")}</td>
                   
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
                    Brak przychodów do wyświetlenia.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>
      </Content>
    </Wrapper>
  );
};

export default Przychody;
